import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { TextArea } from "react-spark";

import {
  withValidationOutputDefaultProps,
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
  sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";

class URCTextArea extends Component {
  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.props.value,
      name: this.props.name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation
    });
  }

  componentDidUpdate() {
    if (this.props.forceUpdate) {
      this.props.context.updateFormElement({
        value: this.props.value,
        name: this.props.name,
        valid: this.props.validateOnRegisterUpdate.apply(this)
      });
    }
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  render() {
    const {
      className,
      context,
      id,
      errorMessage,
      handleChange,
      handleBlur,
      name,
      placeholder,
      rows,
      validation,
      parentContainerClassName,
      value
    } = this.props;

    return (
      <TextArea
        className={className}
        id={id}
        error={errorMessage}
        label={placeholder}
        name={name}
        onChange={e => handleChange(e, context)}
        onBlur={e => handleBlur(e, context.handleChange)}
        required={validation.required}
        rows={rows}
        value={value}
        parentContainerClassName={parentContainerClassName}
      />
    );
  }
}

URCTextArea.defaultTypes = {
  ...withValidationOutputDefaultProps,
  ...sharedFormInputDefaultProps,
  value: "",
  parentContainerClassName: ""
};

URCTextArea.propTypes = {
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  parentContainerClassName: PropTypes.string
};

export default withValidation(URCTextArea, { type: "textarea" });
